// API
import { tmxApiCall } from './index'

export default {
  async searchStoresByZip (zipcode, limit, state) {
    return tmxApiCall('get', '/storeLocator', {
      params: {
        zipcode,
        limit,
        state
      }
    })
  },

  async searchStoresByAddress (address, city, state, zip) {
    return tmxApiCall('get', '/storeByAddress', {
      params: {
        address,
        city,
        state,
        zip
      }
    })
  },

  async updateStore (storeNumber, applicationId) {
    return tmxApiCall('put', '/store', {
      storeNumber,
      applicationId
    })
  }
}
